import ajax from '../utils/ajax'
import moment from 'moment'
import { path } from 'ramda'
import HomepageDispatcher from '../dispatcher/dispatcher'
import ActionTypes from '../constants/Action-Types'
import { buildForm } from '@pcln/home-components'
import { DATE_FORMAT_API, ANALYTICS_CATEGORY } from '../constants/Constants'
import { PCLN_BOOTSTRAP_DATA } from '../constants/PCLN-Data'
import { RECENT_SEARCH_HELPER } from '../utils/recent-searches'
import { OFFER_LIST_P3_ENDPOINT } from '../constants/API-Endpoints'

export default {
  searchRetail (request, isPhone = null) {
    RECENT_SEARCH_HELPER.saveHotelSearch(request)

    if (isPhone) {
      __buildMobileDeeplink(request)
    } else {
      const noDate = !request.checkInDate && !request.checkOutDate
      const formData = __buildBaseHotelForm(request, noDate)
      __handleDesktopLink(request, formData)
    }
  },
  searchRetailCommpnComp (request, isPhone = null) {
    RECENT_SEARCH_HELPER.saveHotelSearch(request)

    if (isPhone) {
      /** Pass in flag since API response keys have changed slightly
       *** location.itemName instead of location.name and location.lon instead of location.long
       **/
      const hotelsMobileFlag = true
      __buildMobileDeeplink(request, hotelsMobileFlag)
    } else {
      const noDate = !request.checkInDate && !request.checkOutDate
      const formData = __buildBaseHotelFormCommonComp(request, noDate)
      __handleDesktopLink(request, formData)
    }
  },

  searchSOPQ (request) {
    const formData = __buildBaseHotelForm(request)

    let formattedCheckInDate
    let formattedCheckOutDate

    const searchType = formData.fields.searchType
      ? formData.fields.searchType.value
      : 'CITY'
    let searchTypePath = ''

    if (formData.fields.checkInDate && formData.fields.checkInDate.value) {
      formattedCheckInDate = moment(formData.fields.checkInDate.value).format(
        DATE_FORMAT_API
      )
    }

    if (formData.fields.checkOutDate && formData.fields.checkOutDate.value) {
      formattedCheckOutDate = moment(formData.fields.checkOutDate.value).format(
        DATE_FORMAT_API
      )
    }

    let cityInfo = ''
    if (searchType === 'CITY') {
      searchTypePath = 'in/'
      if (formData.fields.cityID) {
        cityInfo = formData.fields.cityID.value
      } else if (formData.fields.cityName) {
        cityInfo = formData.fields.cityName.value
      }
    } else if (searchType === 'AIRPORT') {
      searchTypePath = 'near/airport/'
      cityInfo = formData.fields.cityName.value
    } else if (searchType === 'POI') {
      searchTypePath = 'near/poi/'
      if (formData.fields.poiID) {
        cityInfo = formData.fields.poiID.value
      } else if (formData.fields.poiName) {
        cityInfo = formData.fields.poiName.value
      }
    }

    const numberOfRooms = formData.fields.numberOfRooms.value

    const isDatedSearch = formattedCheckInDate && formattedCheckOutDate
    let sopqNewStackPath

    if (isDatedSearch) {
      sopqNewStackPath = `/relax/${searchTypePath}${cityInfo}/from/${formattedCheckInDate}/to/${formattedCheckOutDate}/rooms/${numberOfRooms}/sopq`
    } else {
      sopqNewStackPath = `/relax/${searchTypePath}${cityInfo}/rooms/${numberOfRooms}/sopq`
    }

    window.open(sopqNewStackPath, '_self')
  },

  searchSOPQCommonComp (request) {
    const formData = __buildBaseHotelFormCommonComp(request)

    let formattedCheckInDate
    let formattedCheckOutDate

    let searchType = 'CITY'
    if (formData.fields.searchType && formData.fields.searchType.value) {
      searchType = formData.fields.searchType.value
    }

    if (formData.fields.checkInDate && formData.fields.checkInDate.value) {
      formattedCheckInDate = moment(formData.fields.checkInDate.value).format(
        DATE_FORMAT_API
      )
    }

    if (formData.fields.checkOutDate && formData.fields.checkOutDate.value) {
      formattedCheckOutDate = moment(formData.fields.checkOutDate.value).format(
        DATE_FORMAT_API
      )
    }

    let cityInfo = ''
    let searchTypePath = ''

    if (searchType === 'CITY') {
      searchTypePath = 'in/'
      if (formData.fields.cityID) {
        cityInfo = formData.fields.cityID.value
      } else if (formData.fields.cityName) {
        cityInfo = formData.fields.cityName.value
      }
    }
    if (searchType === 'AIRPORT') {
      searchTypePath = 'near/airport/'
      cityInfo = formData.fields.cityName.value
    }

    if (searchType === 'POI') {
      searchTypePath = 'near/poi/'
      if (formData.fields.poiID) {
        cityInfo = formData.fields.poiID.value
      } else if (formData.fields.poiName) {
        cityInfo = formData.fields.poiName.value
      }
    }

    const numberOfRooms = formData.fields.numberOfRooms.value

    const isDatedSearch = formattedCheckInDate && formattedCheckOutDate
    let sopqNewStackPath

    if (isDatedSearch) {
      sopqNewStackPath = `/relax/${searchTypePath}${cityInfo}/from/${formattedCheckInDate}/to/${formattedCheckOutDate}/rooms/${numberOfRooms}/sopq`
    } else {
      sopqNewStackPath = `/relax/${searchTypePath}${cityInfo}/rooms/${numberOfRooms}/sopq`
    }

    window.open(sopqNewStackPath, '_self')
  },
  toggleSOPQForm (open) {
    HomepageDispatcher.dispatch({
      type: ActionTypes.TOGGLE_SEARCH_FORM,
      form: 'sopq-hotels',
      open
    })
  },

  toggleCollectionsForm (open) {
    HomepageDispatcher.dispatch({
      type: ActionTypes.TOGGLE_SEARCH_FORM,
      form: 'collections-hotels',
      open
    })
  },

  toggleVIPForm (open) {
    HomepageDispatcher.dispatch({
      type: ActionTypes.TOGGLE_SEARCH_FORM,
      form: 'vip-hotels',
      open
    })
  },

  fetchHotelListings (options) {
    const baseUrl = '/pws/v0/stay/integratedlisting/'
    const destination = options.destination
    const checkIn = `${moment(options.checkIn).format(DATE_FORMAT_API)}`
    const checkOut = `${moment(options.checkOut).format(DATE_FORMAT_API)}`
    const allInclusive = false
    const cguid = PCLN_BOOTSTRAP_DATA.webstats.clientGUID
    const currency = 'USD'
    const offset = 0
    const pageName = 'Homepage'
    const pageSize = 10
    const popCountSinceMins = 120
    const productTypes = 'RTL,SOPQ'
    const responseOptions =
      'TRIP_FILTER_SUMMARY,POP_COUNT,DETAILED_HOTEL,NEARBY_CITY,CLUSTER_INFO,SPONS'
    const rguid = `${PCLN_BOOTSTRAP_DATA.webstats.visitId}-${moment().format(
      DATE_FORMAT_API
    )}-${ANALYTICS_CATEGORY}`
    const rooms = 1
    const unlockDeals = true
    const minImageHeight = 154
    const minImageWidth = 260
    const queryParameters = `all-inclusive=${allInclusive}&cguid=${cguid}&check-in=${checkIn}&check-out=${checkOut}&currency=${currency}&offset=${offset}&page-name=${pageName}&page-size=${pageSize}&pop-count-since-mins=${popCountSinceMins}&product-types=${productTypes}&response-options=${responseOptions}&rguid=${rguid}&rooms=${rooms}&unlock-deals=${unlockDeals}&min-image-width=${minImageWidth}&min-image-height=${minImageHeight}`

    ajax({
      url: `${baseUrl}${destination}`,
      data: queryParameters
    }).then(response => {
      HomepageDispatcher.dispatch({
        type: ActionTypes.HOTEL_LISTING,
        data: { response: response.data, options }
      })
    })
  },

  checkCugEligibility () {
    const authtoken = path(['customer', 'authtoken'], window.PCLN_BOOTSTRAP_DATA)

    if (authtoken) {
      ajax({
        url: OFFER_LIST_P3_ENDPOINT,
        type: 'post',
        data: {
          authtoken
        },
        params: {
          'sort-by': 'travel date',
          'offset': 0,
          'limit': 10,
          'sort-order': 'DESC',
          'filter': 'product-id:1,5,8,17;offer-time:past;offer-status:accepted;additional-offer-info:false'
        }
      }).then(response => {
        if (__validateCucEligibility(response)) {
          HomepageDispatcher.dispatch({
            type: ActionTypes.HOTEL_PATH_CUG_ELIGIBLE
          })
        }
      })
    }
  }
}

function __validateCucEligibility (response) {
  const offers = path(['data', 'offers'], response)
  let validHtlBookings = 0

  if (Array.isArray(offers)) {
    for (let i = 0; i < offers.length; i++) {
      const offer = offers[i]
      const productId = offer.productId
      if (productId && !offer.cancelled) {
        if (productId === 5) { // at least 2 hotels
          validHtlBookings++
          if (validHtlBookings === 2) {
            return true
          }
        } else if (productId === 1 || productId === 8) { // any rc or flights within 90days
          const offerTime = offer.offerDateTime
          if (moment().diff(offerTime, 'days') <= 90) {
            return true
          }
        }
      }
    }
  }

  return false
}

function __buildBaseHotelForm (request, noDate) {
  const location = request.location
  const locationType = location.type
  const guests = request.guests
  let locationName = locationType === 'AIRPORT' ? location.id : location.name

  const req = {
    id: 'hotels-form',
    fields: {
      checkInDate: { value: request.checkInDate },
      checkOutDate: { value: request.checkOutDate },
      numberOfRooms: { value: request.roomCount }
    }
  }

  switch (locationType) {
    case 'CITY':
      req.fields.cityID = { value: location.cityId }

      break
    case 'AIRPORT':
      req.fields.searchType = { value: locationType }

      break
    case 'POI':
      req.fields.poiName = { value: locationName }
      req.fields.poiID = { value: location.id }
      req.fields.searchType = { value: 'POI' }

      break
    case 'HOTEL':
      req.fields.hotelNameEntered = { value: locationName }
      req.fields.cityID = { value: location.cityId }
      req.fields.preferredPropID = { value: location.id }
      break
  }

  if (locationType !== 'POI' && locationType !== 'HOTEL') {
    req.fields.cityName = { value: locationName }
  }
  if (noDate === true) {
    req.fields.checkInDate.value = req.fields.checkOutDate = 'mm/dd/yyyy'
    req.fields.noDatesSearch = { value: 'Y' }
  }
  if (guests) {
    if (guests.multiOcc) {
      req.fields.adultOcc = { value: guests.adultCount }

      if (guests.childrenCount > 0) {
        let children = ''

        for (let [i, child] of guests.childrenAges.entries()) {
          children += `${child.room}-${child.age}`

          if (i !== guests.childrenAges.length - 1) {
            children += ','
          }
        }

        req.fields.childOcc = { value: children }
      }
    } else if (guests.singleOcc) {
      const adultCount = request.adultCount

      req.fields.adultOcc = { value: String(adultCount) }

      for (let i = 0; i < request.roomCount; i++) {
        req.fields.adultOcc += `,${adultCount}`
      }
    }
  }

  return req
}

function __buildBaseHotelFormCommonComp (request, noDate) {
  const location = request.location
  const locationType = location.type
  const guests = request.guests
  let locationName =
    locationType === 'AIRPORT' ? location.id : location.itemName

  const req = {
    id: 'hotels-form',
    fields: {
      checkInDate: { value: request.checkInDate },
      checkOutDate: { value: request.checkOutDate },
      numberOfRooms: { value: request.roomCount }
    }
  }

  switch (locationType) {
    case 'CITY':
      req.fields.cityID = { value: location.cityID }

      break
    case 'AIRPORT':
      req.fields.searchType = { value: locationType }

      break
    case 'POI':
      req.fields.poiName = { value: locationName }
      req.fields.poiID = { value: location.id }
      req.fields.searchType = { value: 'POI' }

      break
    case 'HOTEL':
      req.fields.hotelNameEntered = { value: locationName }
      req.fields.cityID = { value: location.cityID }
      req.fields.preferredPropID = { value: location.id }

      break
  }

  if (locationType !== 'POI' && locationType !== 'HOTEL') {
    req.fields.cityName = { value: locationName }
  }
  if (noDate === true) {
    req.fields.checkInDate.value = req.fields.checkOutDate = 'mm/dd/yyyy'
    req.fields.noDatesSearch = { value: 'Y' }
  }
  if (guests) {
    if (guests.multiOcc) {
      req.fields.adultOcc = { value: guests.adultCount }

      if (guests.childrenCount > 0) {
        let children = ''

        for (let [i, child] of guests.childrenAges.entries()) {
          children += `${child.room}-${child.age}`

          if (i !== guests.childrenAges.length - 1) {
            children += ','
          }
        }

        req.fields.childOcc = { value: children }
      }
    } else if (guests.singleOcc) {
      const adultCount = request.adultCount

      req.fields.adultOcc = { value: String(adultCount) }

      for (let i = 0; i < request.roomCount; i++) {
        req.fields.adultOcc += `,${adultCount}`
      }
    }
  }

  return req
}

function __handleDesktopLink (request, formData) {
  const newStackLink = __getDesktopDeepLink(request)
  const form = buildForm(newStackLink, {})
  form.submit()
}

function __getDesktopDeepLink (request) {
  const { location, roomCount, checkInDate, checkOutDate } = request

  const isDatedSearch = checkInDate && checkOutDate

  let locationType = location.type ? location.type.toLowerCase() : 'CITY'
  const locationName = location.name ? location.name : location.itemName // product page uses itemName
  let locationText = location.id
    ? location.id
    : encodeURIComponent(locationName)

  let prefHotelAddOnRelax = ''
  // NOTE: This occAddOn is included only for future use and a reminder where to put multi-occ support when it is needed.
  // Not including it now since there is no existing test of multi-occ on the homepage, and the
  // structure within the hotel path is undergoing change, such that what is here now may well not work
  // when we bring it back anyway. So this occAddOn is just a placeholder for now.
  // let occAddOn = ''

  if (locationType.toLowerCase() === 'hotel') {
    locationType = 'CITY'
    locationText = location.cityId ? location.cityId : location.cityID // product page uses cityID
    prefHotelAddOnRelax = `?preferredhotelids=${location.id}`
  }

  const mobilePath = '/relax'
  if (isDatedSearch) {
    const formattedCheckInDate = moment(checkInDate).format('YYYYMMDD')
    const formattedCheckOutDate = moment(checkOutDate).format('YYYYMMDD')
    if (locationType === 'poi') {
      return `${mobilePath}/near/poi/${locationText}/from/${formattedCheckInDate}/to/${formattedCheckOutDate}/rooms/${roomCount}`
    } else if (locationType === 'airport') {
      return `${mobilePath}/near/airport/${locationText}/from/${formattedCheckInDate}/to/${formattedCheckOutDate}/rooms/${roomCount}`
    } else {
      return `${mobilePath}/in/${locationText}/from/${formattedCheckInDate}/to/${formattedCheckOutDate}/rooms/${roomCount}${prefHotelAddOnRelax}`
    }
  } else {
    if (locationType === 'poi') {
      return `${mobilePath}/near/poi/${locationText}/rooms/${roomCount}`
    } else if (locationType === 'airport') {
      return `${mobilePath}/near/airport/${locationText}/rooms/${roomCount}`
    } else {
      return `${mobilePath}/in/${locationText}/rooms/${roomCount}${prefHotelAddOnRelax}`
    }
  }
}

function __buildMobileDeeplink (request, hotelsMobileFlag = false) {
  const { location, roomCount, checkInDate, checkOutDate } = request
  const locationType = location.type ? location.type.toLowerCase() : 'city'
  const locationName = hotelsMobileFlag ? location.itemName : location.name
  const lat = location.lat ? location.lat : location.latitude
  const lon = location.lon ? location.lon : location.longitude
  let locationText = location.id
    ? location.id
    : encodeURIComponent(locationName)
  // auto select today-tomorrow if no date selected, consistent with m-stay
  function formatCheckInDate (dateFormatStyle) {
    return checkInDate
      ? moment(checkInDate).format(dateFormatStyle)
      : moment().format(dateFormatStyle)
  }

  function formatCheckOutDate (dateFormatStyle) {
    return checkOutDate
      ? moment(checkOutDate).format(dateFormatStyle)
      : moment()
        .add(1, 'days')
        .format(dateFormatStyle)
  }

  const mobilePath = '/relax'
  const formattedCheckInDate = formatCheckInDate('YYYYMMDD')
  const formattedCheckOutDate = formatCheckOutDate('YYYYMMDD')
  if (locationType === 'poi') {
    window.location.href = `${mobilePath}/near/poi/${locationText}/from/${formattedCheckInDate}/to/${formattedCheckOutDate}/rooms/${roomCount}`
  } else if (locationType === 'airport') {
    window.location.href = `${mobilePath}/near/airport/${locationText}/from/${formattedCheckInDate}/to/${formattedCheckOutDate}/rooms/${roomCount}`
  } else if (locationType === 'geo') {
    window.location.href = `${mobilePath}/geo/${locationText}/${lat}/${lon}/from/${formattedCheckInDate}/to/${formattedCheckOutDate}/rooms/${roomCount}`
  } else {
    window.location.href = `${mobilePath}/in/${locationText}/from/${formattedCheckInDate}/to/${formattedCheckOutDate}/rooms/${roomCount}`
  }
}
